import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { sortBy } from 'lodash';
// material
import { Container } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
// app
import { updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar } from '../../../store/action-creators';
// containers
import AdminContainer from '../../../containers/Admin';
// models
import { Auth, Session } from '../../../entities/auth';
import { APIUrl, Campaign, emptyCampaign, CampaignContact, CampaignStats as CampaignStatsEntity } from '../../../entities/site';
import { MessageTemplate, emptyMessageTemplate, MessageGroup, emptyMessageGroup, Message, MessageReceipt as MessageReceiptEntity, emptyMessageReceipt } from '../../../entities/notification';
// components
import Loading from '../../../components/site/Loading';
import MessageReceipt from '../../../components/campaign/MessageReceipt';
import CampaignHeader from './components/CampaignHeader';
import CampaignStatsRun from './components/CampaignStatsRun';
import CampaignContactTableSmall from './components/CampaignContactTablSmall';
import CustomTab from '../../../components/tabs/CustomTab';
import CustomTabs from '../../../components/tabs/CustomTabs';
// services
import CampaignService from '../../../services/campaign';
import AuthService from '../../../services/auth';

interface AdminCampaignRunPageProps {
  match?: any;
  history: any;
  auth: Auth;
  session: Session;
  apiUrls: APIUrl;
  updateSession(session: Session): void;
  setApiUrls(urls: APIUrl): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface AdminCampaignRunPageState {
  loading: boolean;
  campaign: Campaign;
  messageTemplate: MessageTemplate;
  campaignContacts: CampaignContact[];
  lastKey: any;
  totalSent: number;
  counter: number;
  messageGroup: MessageGroup;
  messages: Message[];
  messageReceipt: MessageReceiptEntity;
  showMessageReceipt: boolean;
  status: string;
  tab: number;
}

class AdminCampaignRunPage extends Component<AdminCampaignRunPageProps, AdminCampaignRunPageState> {

  constructor(props: AdminCampaignRunPageProps) {
    super(props);
    this.state = {
      loading: false,
      campaign: emptyCampaign,
      messageTemplate: emptyMessageTemplate,
      campaignContacts: [],
      lastKey: null,
      totalSent: 0,
      counter: 0,
      messageGroup: emptyMessageGroup,
      messages: [],
      messageReceipt: emptyMessageReceipt,
      showMessageReceipt: false,
      status: 'new',
      tab: 0
    }
  }

  componentDidMount = async () => {

    const campaignId = this.props.match.params.id;

    this.fetchCampaign(campaignId);
    this.fetchCampaignContacts(campaignId, this.state.status, null);

  }

  fetchCampaign = async (campaignId: string) => {
    const campaignRes = await axios.get(`${AuthService.getApiUrls().site}/campaign/${campaignId}`);
    const messageTemplateRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/template/${campaignRes.data.templateId}`);
    this.setState({
      campaign: campaignRes.data,
      messageTemplate: messageTemplateRes.data,
      totalSent: campaignRes.data.totalSent
    });
  }

  fetchCampaignContacts = async (campaignId: string, status: string, lastKey: any) => {

    try {

      this.setState({ loading: true });

      let url = `${AuthService.getApiUrls().site}/campaign/${campaignId}/contacts?limit=50&status=${status}`;
      if (lastKey) {
        url += `&id=${lastKey.id}&campaignId=${lastKey.campaignId}`
      }
      const campaignContactsRes = await axios.get(url);

      let contacts = this.state.campaignContacts;
      contacts = contacts.concat(campaignContactsRes.data.results);

      this.setState({
        lastKey: campaignContactsRes.data.lastKey,
        campaignContacts: contacts,
        loading: false
      });

    } catch (error) {
      console.log(error);
    }
  }

  handleShowLoading = () => {
    this.setState({ loading: true });
  }

  handleSendMessage = async (contact: CampaignContact) => {

    try {

      this.setState({ loading: true });
      const updatedCampaign = { ...this.state.campaign };
      let totalSent = this.state.totalSent;
      let updateCampaign = false;
    

      // post to queue
      const campaignContactMessage = {
        type: 'CampaignContactMessage',
        token: this.props.auth.token,
        data: {
          campaignId: this.state.campaign.id,
          campaignContact: contact,
          messageTemplate: this.state.messageTemplate,
          user: this.props.auth.user
        }
      };
      const campaignContactRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contact/send`, campaignContactMessage);
      if (campaignContactRes.data.errorMessage) {
        throw new Error('Error sending campaign contact message');
      }

      // update campaign status, if first run
      if (totalSent === 0) {
        updatedCampaign.status = 'started';
        updateCampaign = true;
      }

      // update campaign status, if finished
      if (totalSent === this.state.campaign.totalContacts) {
        updatedCampaign.status = 'active';
        updateCampaign = true;
      }

      if (updateCampaign) {
        const campaignRes = await axios.put(`${AuthService.getApiUrls().site}/campaign/${this.state.campaign.id}`, updatedCampaign);
        if (campaignRes.data.errorMessage) {
          throw new Error('Error updating campaign');
        }
      }

      totalSent++;
      updatedCampaign.totalSent = totalSent;
      this.setState({
        campaign: updatedCampaign,
        campaignContacts: this.state.campaignContacts.filter(c => c.id !== contact.id),
        loading: false,
        totalSent
      });

      updatedCampaign.totalOptOuts = updatedCampaign.totalOptOuts + 1;

    } catch (error) {
      // error
      console.log('error', error);
    }

  }

  getCampaignStatus = (total: number) => {
    if (total === this.state.campaign.totalContacts) {
      return 'active';
    }

    return 'started';
  }

  handleLoadMore = async () => {
    // load more
    await this.fetchCampaignContacts(this.state.campaign.id, this.state.status, this.state.lastKey);
  }

  handleClick = () => {
    const counter: number = this.state.counter + 1;
    this.setState({ counter })
  }

  handleReceiptClick = async (contact: CampaignContact) => {
    try {

      this.setState({ loading: true });

      const error = '';
      // get message group by contact id
      const messageGroupRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/group/contact/${contact.id}`);

      if (!messageGroupRes.data) {
        throw new Error('Message group not found');
      }

      // get messages by group id
      const messagesRes = await axios.get(`${AuthService.getApiUrls().notifications}/messages/group/${messageGroupRes.data.id}`);

      if (!messagesRes.data) {
        throw new Error('Messages not found');
      }

      // sort by date and get the first
      let messages = messagesRes.data;
      messages = sortBy(messages, 'createdDate');
      const messageId = messages[0].messageId;

      // get ytel receipt
      const receiptRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/integration/${messageId}`);

      if (!receiptRes.data || receiptRes.data.Message360.ResponseStatus !== 1) {
        throw new Error('Messages receipt not found');
      }

      this.setState({
        loading: false,
        messageGroup: messageGroupRes.data,
        messages: messagesRes.data,
        messageReceipt: receiptRes.data.Message360.Message,
        showMessageReceipt: true
      });

      console.log('receiptRes', receiptRes);

    } catch (error) {
      this.setState({ loading: false });
      console.log('error', error);
    }
  }

  handleReceipeClose = () => {
    this.setState({
      messageGroup: emptyMessageGroup,
      messages: [],
      messageReceipt: emptyMessageReceipt,
      showMessageReceipt: false
    });
  }

  a11yProps = (status: string) => {
    return {
      id: `simple-tab-${status}`,
      'aria-controls': `simple-tabpanel-${status}`,
    };
  }

  setTab = async (value: string) => {

    this.setState({
      status: value,
      lastKey: null,
      campaignContacts: []
    });

    await this.fetchCampaignContacts(this.state.campaign.id, value, null);

  }

  render() {

    return (
      <AdminContainer showOption={false} private={false} maxWidth={false}>
        <Loading open={this.state.loading} />
        <Container maxWidth="lg">
          <div style={styles.backContainer} onClick={() => this.props.history.push(`/admin/campaigns/run`)}>
            <ArrowBackIcon style={styles.backIcon} />
            <div style={styles.backText}>Back to campaigns</div>
          </div>
          <CampaignHeader campaign={this.state.campaign} />
          <CampaignStatsRun campaign={this.state.campaign} />
          <div style={styles.tabsContainer}>
            <CustomTabs value={this.state.status} onChange={(event: any, value: string) => this.setTab(value)} aria-label="campaign contact">
              <CustomTab value="new" label="New" {...this.a11yProps('new')} />
              <CustomTab value="sent" label="Sent" {...this.a11yProps('sent')} />
              <CustomTab value="error" label="Errors" {...this.a11yProps('error')} />
            </CustomTabs>

            <div style={styles.tabsBody}>
              <CampaignContactTableSmall
                status={this.state.status}
                campaign={this.state.campaign}
                campaignContacts={this.state.campaignContacts}
                lastKey={this.state.lastKey}
                onLoadMoreClick={this.handleLoadMore}
                onReciptClick={this.handleReceiptClick}
                onClick={this.handleSendMessage}
              />
            </div>
          </div>
          <MessageReceipt
            title="Message Receipt"
            open={this.state.showMessageReceipt}
            messageGroup={this.state.messageGroup}
            messages={this.state.messages}
            messageReceipt={this.state.messageReceipt}
            onClose={this.handleReceipeClose}
          />
        </Container>
      </AdminContainer>
    )
  }


}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
    apiUrls: state.site.apiUrls
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(AdminCampaignRunPage));


const styles: any = {
  tabsContainer: {
    marginTop: 20
  },
  tabsBody: {
    marginTop: 20
  },
  backContainer: {
    paddingTop: 10,
    paddingBottom: 10,
    display: 'flex',
    cursor: 'pointer'
  },
  backIcon: {
    color: '#00adcc'
  },
  backText: {
    paddingLeft: 10,
    color: '#00adcc'
  }
}


// WEBPACK FOOTER //
// ./src/pages/admin/campaign/AdminCampaignRun.tsx